import { Box, Col, Row } from "@reverb-ui/react";
import { panelsInfo } from "helper/panelsHelper";
import { TopFiveSkeleton } from "presentation/components/Skeleton/TopFiveSkeleton";
import { TopFive } from "presentation/components/TopFive";
import { useContext } from "react";
import { TopSummariesContext } from "../context-api/TopSummariesProvider";
import PanelContainer from "presentation/components/PanelContainer";

const topSummariesInfo = panelsInfo.topSummary;

export const TopSummariesReports = () => {
  const {
    requestParamsIndex,
    topSummariesData,
    downloadTopSummariesReport,
    downloadingReports,
    isLoading,
  } = useContext(TopSummariesContext);

  return (
    <PanelContainer
      panelId={topSummariesInfo.htmlId}
      panelName={topSummariesInfo.description}
      rangeName={topSummariesData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadTopSummariesReport,
        downloadingReports: downloadingReports,
        panelInfo: topSummariesInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row marginTop={"1%"}>
        <Col col={4}>
          <Box bg="white" w="full" overflow="auto">
            {isLoading ? (
              <TopFiveSkeleton />
            ) : (
              <TopFive
                title={"TOP 5 PORTFOLIOS"}
                iconName={"Dashboard"}
                data={topSummariesData?.topPortfolios.map((item) => {
                  return {
                    name: item.label,
                    value: `${item.percentageVisitors}%`,
                  };
                })}
              />
            )}
          </Box>
        </Col>
        <Col col={4}>
          <Box bg="white" w="full" overflow="auto">
            {isLoading ? (
              <TopFiveSkeleton />
            ) : (
              <TopFive
                title={"TOP 5 CAMPAIGNS"}
                iconName={"Dashboard"}
                data={topSummariesData?.topCampaigns.map((item) => {
                  return {
                    name: item.label,
                    value: `${item.percentageVisitors}%`,
                  };
                })}
              />
            )}
          </Box>
        </Col>
        <Col col={4}>
          <Box bg="white" w="full" overflow="auto">
            {isLoading ? (
              <TopFiveSkeleton />
            ) : (
              <TopFive
                title={"TOP 5 CREATIVES"}
                iconName={"Dashboard"}
                data={topSummariesData?.topCreatives.map((item) => {
                  return {
                    name: item.label,
                    value: `${item.percentageVisitors}%`,
                  };
                })}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
